import { render, staticRenderFns } from "./AvbTable.vue?vue&type=template&id=57585cc4"
import script from "./AvbTable.vue?vue&type=script&lang=js"
export * from "./AvbTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports